import { CbTooltipModule } from '@chubb/ui-components/cb-tooltip';
import { CbInputModule } from '@chubb/ui-components/cb-input';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CsbWebsiteComponent } from './csb-website.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { AppAnalyticsModule } from '../../directives/app-analytics.module';
import { NotificationsModule } from '../../components/notifications/notifications.module';
import { ErrorBoxModule } from './../../components/error-box/error-box.module';
import { RouterModule } from '@angular/router';
import { CSBCoreModule } from '../../csb-core/csb-core.module';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonToggleModule,
        CSBCoreModule,
        MatFormFieldModule,
        MatSelectModule,
        MatCheckboxModule,
        CbInputModule,
        CbTooltipModule,
        AppAnalyticsModule,
        NotificationsModule,
        ErrorBoxModule,
        RouterModule,
    ],
    declarations: [CsbWebsiteComponent],
    exports: [CsbWebsiteComponent],
})
export class CsbWebsiteModule {}
